import * as Highcharts from 'highcharts';
import { Router } from '@angular/router';
import { ReusableFunctions } from './reusable-functions';

export class FinancialsCompSnapshotCharts {
    constructor(private router: Router, private reusableFunctions: ReusableFunctions) {}

    createWaterfallChart(seriesInfo: any[]): Highcharts.Options {
        Highcharts.setOptions({
            lang: {
                thousandsSep: ',',
            },
        });

        return {
            chart: {
                type: 'waterfall',
                height: 550,
                spacingBottom: 8,
                spacingLeft: 0,
                marginRight: 0,
                spacingRight: 0,
                spacingTop: 0,
                events: {},
            },
            title: {
                text: 'Net Pay',
                align: 'left',
                x: 10,
                y: 30,
                margin: 40,
                style: {
                    fontSize: '20px',
                },
            },
            credits: {
                enabled: false,
            },
            xAxis: [
                {
                    type: 'category',
                } as Highcharts.XAxisOptions,
            ],
            yAxis: {
                title: {
                    text: 'USD',
                    style: {
                        fontSize: '10px',
                        color: '#666666',
                    },
                },
                labels: {
                    enabled: true,
                    style: {
                        fontSize: '10px',
                        color: '#666666',
                    },
                },
                lineWidth: 1,
            },
            tooltip: {
                enabled: false,
            } as Highcharts.TooltipOptions,
            plotOptions: {
                area: {
                    lineColor: '#E5E5E5',
                    lineWidth: 4,
                },
                series: {
                    marker: {
                        enabled: false,
                        symbol: 'circle',
                    },
                    label: {
                        enabled: false,
                    },
                },
            },
            exporting: {
                enabled: false,
            },
            series: this.formatSeriesInfo(seriesInfo),
        };
    }

    formatSeriesInfo(seriesInfo: any[]) {
        let series = [];
        const data = [...seriesInfo];
        for (let info of seriesInfo) {
            if (info.name === 'Net Pay') {
                info.isSum = true;
            }
        }
        let dataItems = {
            data,
            dataLabels: {
                enabled: true,
                formatter: function () {
                    return '$' + Highcharts.numberFormat(this.y, 2);
                },
            },
            pointPadding: 0,
            showInLegend: false,
        };

        series.push(dataItems);
        return series;
    }
}

export interface AreaChartDatapoint extends Highcharts.PointOptionsObject {}
